import React from 'react';
import { CustomerWelcomeMessage } from '@thd-olt-component-react/customer-welcome-message';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function WelcomeMessage() {

  return (
    <ErrorBoundary name="welcome-message">
      <CustomerWelcomeMessage />
    </ErrorBoundary>
  );
}
